import {styled} from '@mui/material/styles'
import Typography from '@mui/material/Typography'
const PREFIX = 'TermsOfUse'

const classes = {
  underlineHeadings: `${PREFIX}-underlineHeadings`
}

// eslint-disable-next-line no-unused-vars
const Root = styled('div')(({theme}) => ({
  color: 'black',
  [`& .${classes.underlineHeadings}`]: {
    textDecoration: 'underline',
    fontWeight: 700,
    fontSize: theme.typography.heading.fontSize.s18
  }
}))

const StyledTypography = styled(Typography)(({theme}) => ({
  color: theme.palette.common.black,
  fontSize: theme.typography.heading.fontSize.xs,
  marginBottom: '16px'
}))

const TermsOfUse = () => {
  return (
    <Root aria-label="terms-of-use">
      <StyledTypography variant="body1" component="div" gutterBottom>
        These Terms of Use apply to your use of the site that links to this Terms of Use document (the “site”). To the
        extent there is an executed agreement with Deloitte Consulting LLP (“we” or “us”) governing your access to and
        use of the application available on this site (an “Agreement”), your use and access to any such application will
        be further governed by such Agreement. To the extent there is a conflict between these Terms of Use and an
        Agreement, the terms of the Agreement shall control.{' '}
        <b>
          By using this site, you are agreeing to these Terms of Use. If you do not agree to these Terms of Use, then
          you are not allowed to use this site and should immediately terminate such usage.
        </b>
      </StyledTypography>
      <StyledTypography className={classes.underlineHeadings} component="div" gutterBottom>
        Use of Content; Restrictions
      </StyledTypography>
      <StyledTypography variant="body1" component="div" gutterBottom>
        Unless otherwise indicated in the relevant content, and on the condition that you comply with all of your
        obligations under these Terms of Use, (i) you are authorized only to view and print the content on this site for
        informational, noncommercial purposes and provided that any copy of the content that you make must include the
        copyright notice or other attribution associated with the content; and (ii) you are not authorized to copy or
        use any software, proprietary processes or technology embodied or described in this site.
        <br></br>
        <br></br>
        You will comply with all applicable laws in accessing and using this site. You acknowledge that we may use your
        personal information and data according to our Privacy Statement, set forth in the Privacy link on this site.
        <br></br>
        <br></br>
        This site and its contents are protected by copyright, trademark, and other laws of the United States and/or
        other countries. We and our licensors reserve all rights not expressly granted in these Terms of Use. References
        to other parties’ trademarks on this site are for identification purposes only and do not indicate that such
        parties have approved this site or any of its contents, nor should they be construed as an endorsement of them
        or their content by us.
      </StyledTypography>
      <StyledTypography className={classes.underlineHeadings} component="div" gutterBottom>
        Disclaimers and Limitations of Liability
      </StyledTypography>
      <StyledTypography variant="body1" component="div" gutterBottom>
        THIS SITE CONTAINS GENERAL INFORMATION ONLY, AND WE ARE NOT, BY MEANS OF THIS SITE, RENDERING PROFESSIONAL
        ADVICE OR SERVICES. BEFORE MAKING ANY DECISION OR TAKING ANY ACTION THAT MIGHT AFFECT YOUR FINANCES OR BUSINESS,
        YOU SHOULD CONSULT A QUALIFIED PROFESSIONAL ADVISOR. <br></br>
        <br></br>
        THIS SITE IS PROVIDED AS IS, AND WE MAKE NO EXPRESS OR IMPLIED REPRESENTATIONS OR WARRANTIES REGARDING IT.
        WITHOUT LIMITING THE FOREGOING, WE DO NOT WARRANT THAT THIS SITE WILL BE SECURE, ERROR-FREE, FREE FROM VIRUSES
        OR MALICIOUS CODE, OR WILL MEET ANY PARTICULAR CRITERIA OF PERFORMANCE OR QUALITY. WE EXPRESSLY DISCLAIM ALL
        IMPLIED WARRANTIES, INCLUDING, WITHOUT LIMITATION, WARRANTIES OF MERCHANTABILITY, TITLE, FITNESS FOR A
        PARTICULAR PURPOSE, NON-INFRINGEMENT, COMPATIBILITY, SECURITY, AND ACCURACY.<br></br>
        <br></br>
        YOUR USE OF THIS SITE IS AT YOUR OWN RISK AND YOU ASSUME FULL RESPONSIBILITY AND RISK OF LOSS RESULTING FROM
        YOUR USAGE, INCLUDING, WITHOUT LIMITATION, WITH RESPECT TO LOSS OF SERVICE OR DATA. WE WILL NOT BE LIABLE FOR
        ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES OR ANY OTHER DAMAGES WHATSOEVER,
        RELATING TO OR ARISING OUT OF THE USE OF THIS SITE, EVEN IF WE KNEW, OR SHOULD HAVE KNOWN, OF THE POSSIBILITY OF
        SUCH DAMAGES. <br></br>
        <br></br>
        THE ABOVE DISCLAIMERS AND LIMITATIONS OF LIABILITY ARE APPLICABLE TO THE FULLEST EXTENT PERMITTED BY LAW,
        WHETHER IN CONTRACT, STATUTE, TORT (INCLUDING, WITHOUT LIMITATION, NEGLIGENCE) OR OTHERWISE.
      </StyledTypography>
      <StyledTypography className={classes.underlineHeadings} component="div" gutterBottom>
        Additional Terms
      </StyledTypography>
      <StyledTypography variant="body1" component="div" gutterBottom>
        If any portion of these Terms of Use is invalid or unenforceable in any jurisdiction, then (i) in that
        jurisdiction it shall be re-construed to the maximum effect permitted by law in order to effect its intent as
        nearly as possible, and the remainder of these Terms of Use shall remain in full force and effect, and (ii) in
        every other jurisdiction, all of these Terms of Use shall remain in full force and effect. <br></br>
        <br></br>
        We may revise these Terms of Use at any time in our sole discretion by posting such revised Terms of Use at the
        Terms of Use link or elsewhere in this site. Such revisions shall be effective as to you upon posting, unless
        explicitly stated by us. It is your responsibility to be aware of any such revised Terms of Use by checking this
        webpage. Your continued use of this site following changes to these Terms of Use constitutes your agreement to
        the revised Terms of Use.
      </StyledTypography>
    </Root>
  )
}

export default TermsOfUse
